/* eslint-disable @typescript-eslint/naming-convention */
export enum FormFieldTypes {
  None = 0,
  Text = 1,
  TextArea = 2,
  DatePicker = 3,
  DateTimePicker = 4,
  Boolean = 5,
  Number = 6,
  Select = 7,
}
